import type { Dayjs } from 'dayjs';
import { z } from 'zod';
import { LogPeriodo } from './enum';

export const LogSchema = z.object({
    log_data_insercao: z.string(),
    log_descricao: z.string(),
    log_empresa_idpk: z.number(),
    log_idpk: z.string(),
    log_nivel: z.number(),
    log_origem: z.number(),
    log_origem_id: z.string(),
    log_tipo: z.number(),
    log_usuario_idpk: z.number().nullable(),
    log_usuario_nome: z.string(),
});

export type Log = z.infer<typeof LogSchema>;

export type FormLogParams = {
    log_descricao: string;
    log_data_insercao: string;
    log_tipo: string;
    log_usuario_nome: string;
};

export type LogFilter = {
    date_range?: Dayjs[];
    log_origem?: number;
    log_tipo?: number[];
    log_descricao?: string;
    log_origem_idpk?: number;
    origem_idpk?: number;
};

export const LOG_PERIODO_INFO: Record<
    LogPeriodo,
    { label: string; dias: number | null; texto: string }
> = {
    [LogPeriodo.TODO_PERIODO]: {
        dias: null,
        label: 'Todo o período enquanto estiver ativado',
        texto: 'todo o período enquanto estiver ativado',
    },
    [LogPeriodo.TRES_DIAS]: {
        dias: 3,
        label: 'Três dias (3 dias)',
        texto: 'nos últimos 3 dias',
    },
    [LogPeriodo.UMA_SEMANA]: {
        dias: 7,
        label: 'Uma semana (7 dias)',
        texto: 'nos últimos 7 dias',
    },
    [LogPeriodo.DUAS_SEMANAS]: {
        dias: 14,
        label: 'Duas semanas (14 dias)',
        texto: 'nos últimos 14 dias',
    },
    [LogPeriodo.UM_MES]: {
        dias: 30,
        label: 'Um mês (30 dias)',
        texto: 'nos últimos 30 dias',
    },
    [LogPeriodo.DOIS_MESES]: {
        dias: 60,
        label: 'Dois meses (60 dias)',
        texto: 'nos últimos 60 dias',
    },
    [LogPeriodo.TRES_MESES]: {
        dias: 90,
        label: 'Três meses (90 dias)',
        texto: 'nos últimos 90 dias',
    },
    [LogPeriodo.SEIS_MESES]: {
        dias: 180,
        label: 'Seis meses (180 dias)',
        texto: 'nos últimos 180 dias',
    },
    [LogPeriodo.UM_ANO]: {
        dias: 365,
        label: 'Um ano (365 dias)',
        texto: 'nos últimos 365 dias',
    },
};
